import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-grace-period-countdown',
  imports: [CommonModule],
  template: `
    <span class="text-[#212121]">
      {{ display }}
    </span>
  `,
  //  [ngClass]="{'text-[#212121]': isExpiring, 'text-green-600': !isStatic && !isExpired && !isExpiring, 'text-gray-400': isExpired || isStatic}" color classes

})
export class GracePeriodCountdownComponent implements OnDestroy {
  params: any;
  display: string = '-';
  isExpired: boolean = false;
  isExpiring: boolean = false;
  isStatic: boolean = false;
  @Output() expired = new EventEmitter();
  private intervalId: any;

  agInit(params: any): void {
    this.params = params;
    if (params.data?.grace_period_display) {
      this.display = params.data.grace_period_display;
      this.isStatic = true;
      return;
    }
    this.isStatic = false;
    this.startCountdown();
  }

  refresh(params: any): boolean {
    this.params = params;
    this.clearInterval();
    if (params.data?.grace_period_display) {
      this.display = params.data.grace_period_display;
      this.isStatic = true;
      return true;
    }
    this.isStatic = false;
    this.startCountdown();
    return true;
  }

  private startCountdown(): void {
    let endTime = this.params.data?.grace_period_end_time || 0;
    if (!endTime) {
      const expiryStr = this.params.data?.grace_period_expiry;
      if (expiryStr) endTime = new Date(expiryStr).getTime();
    }

    if (!endTime) {
      this.display = '-';
      return;
    }

    const remaining = endTime - Date.now();
    if (remaining <= 0) {
      this.display = '-';
      this.isExpired = true;
      this.isExpiring = false;
      // Grace period already expired — notify backend so is_grace_period_active gets set to false
      if (this.params?.onExpired) {
        this.params.onExpired(this.params);
      }
      return;
    }

    this.updateDisplay(endTime);
    this.intervalId = setInterval(() => this.updateDisplay(endTime), 1000);
  }

  private updateDisplay(endTime: number): void {
    const remaining = endTime - Date.now();

    if (remaining <= 0) {
      this.display = '0 min';
      this.isExpired = true;
      this.isExpiring = false;
      this.expired.emit();
      if (this.params && this.params.onExpired) {
        this.params.onExpired(this.params);
      }
      this.clearInterval();
      return;
    }

    this.isExpired = false;
    // Mark as expiring when less than 5 minutes remain
    this.isExpiring = remaining < 5 * 60 * 1000;

    const totalMinutes = Math.floor(remaining / 60000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const seconds = Math.floor((remaining % 60000) / 1000);

    if (hours > 0) {
      this.display = minutes > 0 ? `${hours} Hours ${minutes} Mins` : `${hours} Hours`;
    } else if (minutes > 0) {
      this.display = seconds > 0 ? `${minutes} Mins ${seconds} Secs` : `${minutes} Mins`;
    } else {
      this.display = seconds > 0 ? `${seconds} Secs` : `0 min`;
    }
  }

  private clearInterval(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  ngOnDestroy(): void {
    this.clearInterval();
  }
}